<script>
import { mapActions } from 'vuex'
export default {
  name: 'authentication-logout',
  render() {
    return false
  },
  created() {
    localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`)
    // this.resetUser()
    // localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationId`)
    this.resetClassRoom()
    this.$router.push({ path: '/login' })
  },
  methods: {
    ...mapActions("teacherLayout", ['resetClassRoom']),
  }
}
</script>
